export const FULL_PERCENT = 100;
export const PROGRESS_INTERVAL = 1000;
